import React, {Fragment, useState, useEffect} from 'react';
import {
    Checkbox,
    DatePicker,
    Form,
    Icon,
    Input,
    InputNumber,
    Radio,
    Select,
    TimePicker,
    Upload,
    message,
    TreeSelect,
    ConfigProvider
} from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import {setCache} from "../utils/cache";
// import Params from "../components/Params"
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

let timer = 180;

const {Option} = Select;
const {TextArea} = Input;
const fileTypes = ".png,.jpg,.jpeg,.gif,.bmp,.tiff," +
    ".rmvb,.rm,.flv,.mp4,.mid,.3GP,.mpg,.mov,.mkv,.mp3,.wma,.wav," +
    ".rar,.zip,.tar,.gz,.7z,.bz2,.cab,.iso," +
    ".xls,.xlsx,.csv,.pdf,.doc,.docx,.odc,.txt,.wps,.et,.xps,.rtf,.ppt,.pptx,.otd";

function validateConfig(item, LOCALE_HTML) {
    let rules = [];
    let type = '';
    if (item.fieldType !== 5) {
        type = limit(item);
    } else {
        type = checkNum(item);
    }
    if (type === 'char') {
        rules.push({message: LOCALE_HTML['msg.toast.char'], pattern: /^[\u4E00-\u9FA5A-Za-z0-9]+$/});
    }
    if (type === 'num') {
        rules.push({message: LOCALE_HTML['msg.toast.num'], pattern: /^[0-9]+$/});
    }
    if (type === 'dot') {
        rules.push({message: LOCALE_HTML['msg.toast.num'], pattern: /^(([1-9]\d*)|(0))(\.\d{0,2})?$/});
    }
    if (item.fillFlag === 1) {
        if(item.type === 'tel' || type === 'tel'){
            rules.push({required: true, message: LOCALE_HTML['msg.toast.noTel']});
        }else if(item.type === 'email' || type === 'email'){
            rules.push({required: true, message: LOCALE_HTML['msg.toast.noEmail']});
        }else if(item.type === 'annex'){
            rules.push({required: true, message: LOCALE_HTML['msg.toast.noAnnex']});
        }else {
            rules.push({required: true, message: `${item.fieldName}${LOCALE_HTML['msg.toast.none']}`});
        }
    }
    if (item.enclosureFlag === 1) {
        rules.push({required: true, message: LOCALE_HTML['msg.toast.annex']});
    }
    if (item.emailFlag === 1 || type === 'email') {
        rules.push({type: 'email', message: LOCALE_HTML['msg.toast.email']});
    }
    if (item.telFlag === 1 || type === 'tel') {
        rules.push({message: LOCALE_HTML['msg.toast.tel'], pattern: /^1[1-9]\d{9}$/});
    }
    return rules;
}

function checkNum(option) {
    if (option.limitOptions && option.limitOptions.length > 0) {
        const item = option.limitOptions;
        let num = false;
        let dot = false;
        item.forEach(id => {
            if (id === 2 && dot === false) {
                num = true;
            }
            if (id === 3) {
                dot = true;
                num = false;
            }
        });
        if (num) {
            return 'num';
        }
        if (dot) {
            return 'dot';
        }
    }
}

function limit(option) {
    if (option.limitOptions && option.limitOptions.length > 0) {
        const item = option.limitOptions;
        let charFlag = false;
        let numFlag = false;
        let emailFlag = false;
        let telFlag = false;
        item.forEach(id => {
            if (id === 7) {//邮箱
                emailFlag = true;
                telFlag = false;
                numFlag = false;
                charFlag = false;
            }
            if (id === 8 && emailFlag === false) {//手机号
                telFlag = true;
                numFlag = false;
                charFlag = false;
            }
            if (id === 5 && emailFlag === false && telFlag === false) {
                numFlag = true;
                charFlag = false;
            }
            if (id === 4 && emailFlag === false && telFlag === false && numFlag === false) {
                charFlag = true;
            }
        });
        if (charFlag) {
            return 'char';
        }
        if (numFlag) {
            return 'num';
        }
        if (emailFlag) {
            return 'email';
        }
        if (telFlag) {
            return 'tel';
        }
    }

}

function filterFile(e) {
    if (Array.isArray(e)) {
        return e;
    }
    return e && e.fileList;
}

function BaseField(props) {
    const [fileList, setFileList] = useState([]);
    const {getFieldDecorator} = props.form;
    const {ids, item,sbumitFlag, LOCALE_HTML} = props;
    let text = '';
    if (item.msgTmp) {
        text = item.msgTmp.replace(/&#39;|&nbsp;|&amp;|&lt;|&gt;|&quot;/g, "");
    }
    let emailRules = validateConfig({
        fillFlag: item.emailFlag,
        emailFlag: 1,
        type: 'email',
    }, LOCALE_HTML);
    let enclosureRules = validateConfig({
        fillFlag: item.enclosureFlag,
        type: 'annex',
    }, LOCALE_HTML);
    let telRules = validateConfig({
        fillFlag: item.telFlag,
        telFlag: 1,
        type: 'tel',
    }, LOCALE_HTML);
    const fileConfig = {
        action: '/chat/webchat/fileUploadForPostMsgBypc.action',
        accept: fileTypes,
        multiple: true,
        data: {
            type: 'msg',
            countTag: 1,
            source: 0,
            pid: ids.companyId,
            uid: ids.uid
        },
        onChange({file, fileList}) {
            fileList = fileList.slice(0, 10);
            fileList = fileList.filter(file => {
                if (file.response) {
                    file.url = file.response.url;
                }
                const type = file.name.split('.')[file.name.split('.').length - 1];
                if (fileTypes.indexOf(type.toLocaleLowerCase()) === -1) {
                    return false;
                } else if (file.size / 1024 / 1024 > 200) {
                    return false;
                } else {
                    return file;
                }
            });

            setFileList(fileList);
        },
        beforeUpload(file) {
            const type = file.name.split('.')[file.name.split('.').length - 1];
            if (fileTypes.indexOf(type.toLocaleLowerCase()) === -1) {
                message.error(LOCALE_HTML["msg.form.uploadError"], 2);
                return false;
            }
            // if (file.size / 1024 / 1024 > 20) {
            //     message.error(LOCALE_HTML['file.size.limit'], 2);
            //     return false;
            // }
            if (file.size / 1024 / 1024 > 200) {
                message.error(LOCALE_HTML['file.size.limit'], 2);
                return false;
            }
            if (fileList.length > 9) {
                message.error(LOCALE_HTML['file.count.limit'], 2);
                return false;
            }
        }
    };

    const changeTicketContent = (e)=> {
        const value = e.target.value;
        const dom = document.querySelector("#js-tip");
        if(value){
            dom.style.display = "none";
        }else{
            dom.style.display = "block";
        }
    }

    const clickTip = ()=> {
        const dom = document.querySelector("#customField_ticketContent");
        dom.focus();
    }

    useEffect(() => {
        if (sbumitFlag) {
            setFileList([]);
        }
    }, [sbumitFlag]);

    return (
        <Fragment>
            <div className="zc-ticketContent">
                <Form.Item label={LOCALE_HTML['msg.des']} style={{marginBottom:0}}>
                    {
                        getFieldDecorator('ticketContent', {
                            rules: [{required: true, message: LOCALE_HTML['form.question.des.tip']}],
                            // getValueFromEvent: e => e.target.value.replace(/(^\s*)|(\s*$)/g, "")
                        })(<TextArea onChange={changeTicketContent} style={{ minHeight:"110px" }}/>)
                    }
                </Form.Item>
                <div id="js-tip" onClick={clickTip} className="tip" dangerouslySetInnerHTML={{ __html:text }}/>
            </div>
            {
                item.enclosureShowFlag ? (<Form.Item>
                    {
                        getFieldDecorator('fileStr', {
                            rules: enclosureRules,
                            getValueFromEvent: filterFile
                        })(<Upload {...fileConfig} fileList={fileList}>
                            <span className="upload-btn"><Icon type="paper-clip" className="attachments-icon"/>{LOCALE_HTML['upload.file']}</span><span className="tip-text">({LOCALE_HTML['detail.file.limit']})</span>
                        </Upload>)
                    }
                </Form.Item>) : null
            }
            {
                item.emailShowFlag ? (<Form.Item label={LOCALE_HTML['msg.email']}>
                    {
                        getFieldDecorator('customerEmail', {
                            rules: emailRules,
                            getValueFromEvent: e => e.target.value.replace(/(^\s*)|(\s*$)/g, "")
                        })(<Input placeholder={LOCALE_HTML['msg.form.input']}/>)
                    }
                </Form.Item>) : null
            }
            {
                item.telShowFlag ? (<Form.Item label={LOCALE_HTML['msg.phone']}>
                    {
                        getFieldDecorator('customerPhone', {
                            rules: telRules,
                            getValueFromEvent: e => e.target.value.replace(/(^\s*)|(\s*$)/g, "")
                        })(<Input maxLength={11} placeholder={LOCALE_HTML['msg.form.input']}/>)
                    }
                </Form.Item>) : null
            }
        </Fragment>
    )
}

function customField(props) {
    const {item, fieldConfig, ticketTypeList, LOCALE_HTML, dispatch} = props;
    const {getFieldDecorator} = props.form;
    const formItems = fieldConfig.map((obj, index) => {
        // 新增需求 - 账号注销模版中新增手机验证码功能 start
        const [styleFlag, setStyleFlag] = useState(false);
        const [verificationCodeText, setVerificationCodeText] = useState('获取验证码');
        // 验证码重新发送倒计时
        const timeoutChange = () => {
            if (timer === 0) {
                setStyleFlag(false);
                setVerificationCodeText('获取验证码');
            } else {
                var str = timer + ' 秒后重新发送';
                setStyleFlag(true);
                setVerificationCodeText(str)
                setTimeout(() => {
                    timeoutChange();
                }, 1000)
            }
            timer--;
        };
        // 获取验证码
        const getVerificationVode = (name) => {
            const verifyName = name == '手机验证码' ? '手机账号' : '更改为手机号'
            const type = name == '手机验证码' ? '' : 1
            timer = 180;
            const fieldFormValueData = props.form ? props.form.getFieldsValue() : '';
            let phoneItem = {},
                phoneValue = '';
            // 获取【手机账号】的id
            fieldConfig.forEach(item => {
                if(item.cusFieldConfig && item.cusFieldConfig.fieldName === verifyName) {
                    phoneItem = item;
                }
            });
            const phoneFieldId = phoneItem && phoneItem.cusFieldConfig ? phoneItem.cusFieldConfig.fieldId : '';
            // 获取【手机账号】或新手机号的value
            fieldFormValueData.extendFields.map(item => {
                if(item.id === phoneFieldId) {
                    phoneValue = item.value;
                }
            })
            if(!phoneValue) {
                message.warn('请填写手机账号', 2);
            } else {
                dispatch({
                    type: 'app/getCode',
                    payload: {
                        phoneNo: phoneValue,
                        type
                    },
                    callback: function (ret) {
                        if(ret && ret.retCode === '0') {
                            timeoutChange();
                        } else {
                            message.warn(ret.retMsg || '短信发送失败', 2);
                        }
                    }
                });
            }
        }
        // end
        
        const k = obj.cusFieldConfig;
        const list = obj.cusFieldDataInfoList;
        const rules = validateConfig(k, LOCALE_HTML);
        let item;
        let key = `extendFields[${index}][value]`;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
            marginLeft: 0
        };
        getFieldDecorator(`extendFields[${index}][id]`, {initialValue: k.fieldId});
        if (k.fieldType === 1) {//单行文本1
            item = getFieldDecorator(key, {
                rules,
                // getValueFromEvent: e => e.target.value.replace(/(^\s*)|(\s*$)/g, "")
            })(
                k.fieldName !== '手机验证码' && k.fieldName !== '新手机验证码' ? <Input maxLength={Number(k.limitChar)} placeholder={LOCALE_HTML['msg.form.input']}/> : 
                <div className='verification-container'>
                    <Input maxLength={Number(k.limitChar)} placeholder={LOCALE_HTML['msg.form.input']}/>
                    { styleFlag ? <div className='timeout-change-style'>{verificationCodeText}</div> : 
                        <div className='verification-code-text' onClick={() =>getVerificationVode(k.fieldName)}>{verificationCodeText}</div>
                    }
                </div>
            )
        } else if (k.fieldType === 2) {//多行文本2
            item = getFieldDecorator(key, {
                rules,
                // getValueFromEvent: e => e.target.value.replace(/(^\s*)|(\s*$)/g, "")
            })(<TextArea rows={3} placeholder={LOCALE_HTML['msg.form.input']}/>)
        } else if (k.fieldType === 3) {//日期3
            item = getFieldDecorator(key, {
                rules,
            })(<DatePicker/>)
        } else if (k.fieldType === 4) {//时间4
            item = getFieldDecorator(key, {
                rules,
            })(<TimePicker format="HH:mm"/>)
        } else if (k.fieldType === 5) {//数值5
            item = getFieldDecorator(key, {
                rules,
            })(<InputNumber style={{'width': 200}} parser={value => value.replace(/[^\d.]/g, '')}/>)
        } else if (k.fieldType === 6) {//下拉列表6
            item = getFieldDecorator(key, {
                rules,
            })(
                <Select
                    suffixIcon={<svg className="zc-arrow" aria-hidden="true"><use xlinkHref="#iconshouqi2"/></svg>}
                    showSearch={k.queryFlag === 1}
                        placeholder={LOCALE_HTML['msg.form.choose']}
                        dropdownClassName="zc-select"
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}>
                    {
                        list.map((j, index) => (
                            <Option value={j.dataValue} key={j.dataValue}>{j.dataName}</Option>
                        ))
                    }
                </Select>)
        } else if (k.fieldType === 7) {//复选框7
            item = getFieldDecorator(key, {
                rules,
            })(
                <Checkbox.Group>
                    {
                        list.map((j, index) => (
                            <Checkbox style={radioStyle} value={j.dataValue} key={j.dataValue}>{j.dataName}</Checkbox>
                        ))
                    }
                </Checkbox.Group>
            )
        } else if (k.fieldType === 8) {//单选框8
            item = getFieldDecorator(key, {
                rules,
            })(
                <Radio.Group>
                    {
                        list.map((j, index) => (
                            <Radio style={radioStyle} value={j.dataValue} key={j.dataValue}>{j.dataName}</Radio>
                        ))
                    }
                </Radio.Group>
            )
        } else {
            item = null;
        }
        return (
            <Form.Item key={index} label={k.fieldName}>
                {item}
            </Form.Item>
        )
    });

    const onSelect =(value,node) => {
        setCache("typePathName",node.props.typePathName)
        setCache("typePathId",node.props.typePathId)
    }

    return (
        <ConfigProvider locale={LOCALE_HTML['msg.language'] === 'cn'? zhCN : null}>
            <Form layout="vertical">
                {/*<Params />*/}
                {
                    item.ticketTitleShowFlag === 1 ? <Form.Item label={LOCALE_HTML['msg.title']}>
                        {
                            getFieldDecorator("ticketTitle",{
                                rules: [{required: true, message: LOCALE_HTML['form.title.tip']}],
                            })(<Input maxLength={100} placeholder={LOCALE_HTML['msg.form.input']}/>)
                        }
                    </Form.Item> : null
                }
                {
                    item.ticketTypeFlag === 1 ? <Form.Item label={LOCALE_HTML['msg.type']}>
                        {
                            getFieldDecorator('ticketTypeId', {
                                rules: [{required: true, message: LOCALE_HTML['form.class.tip']}],
                            })(
                                <TreeSelect
                                    suffixIcon={<svg className="zc-arrow" aria-hidden="true"><use xlinkHref="#iconshouqi2"/></svg>}
                                    showSearch
                                    searchPlaceholder={LOCALE_HTML['select.search.placeholder']}
                                    treeNodeFilterProp="typeName"
                                    dropdownClassName="zc-treeSelect"
                                    style={{width: '100%'}}
                                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                    onSelect={onSelect}
                                    treeData={ticketTypeList}
                                    placeholder={LOCALE_HTML['msg.form.choose']}
                                />)
                        }
                    </Form.Item> : null
                }
                {formItems}
                <BaseField {...props}/>
            </Form>
        </ConfigProvider>
    )
}

const WrappedCustomField = Form.create({name: 'customField'})(customField);

export default WrappedCustomField;
